<template>
  <el-row type="flex" align="middle">
    <gj-select
        class="gj-select"
        v-model="value['key']"
        :placeholder="placeholder[1]"
        :width="mapSelectWidth"
        :options="options"
        @input="$emit('input', value)"
        @change="$emit('prefix-change', value)"
        :clearable="false"
    ></gj-select>
    <gj-date-picker
        v-model="value['value']"
        :type="type"
        :shortcut="shortcut"
        :shortcuts="shortcuts"
        :width="mapDateWidth"
        :clearable="dateClearable"
        :max-day-length="maxDayLength"
        :disabledDate="disabledDate"
        :tooltip="tooltip"
        :value-format="valueFormat"
        :format="format"
        @change="val => $emit('change', val)"
        @input="$emit('input', value)"
        @shortcut-text="shortcutText = $event"
    ></gj-date-picker>
  </el-row>
</template>

<script>
  import GjDatePicker from "./gj-date-picker";
  import GjSelect from "../select/gj-select";
  import {defaultVal, isMeaningful} from "../../utils/common";
  import {tooltipMixin} from "../../minxins";

  export default {
    name: "gj-select-date-picker",
    mixins: [tooltipMixin],
    components: {GjSelect, GjDatePicker},
    props: {
      value: {
        type: Object,
        required: true
      },
      placeholder: {
        type: Array,
        default: () => ['请选择', '请选择']
      },
      type: {
        type: String,
        default: 'date'
      },
      width: {
        type: Array
      },
      options: {
        type: Array,
        required: true
      },
      dateClearable: {
          type: Boolean,
          default: true,
      },
      maxDayLength: {
        type: Number,
        default: null
      },
      shortcut:{
        type: Boolean,
        default: true
      },
      disabledDate: {
        default: null
      },
      shortcuts: {
        type: Array,
        default: () => ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'],
      },
      valueFormat: String,
      format: String
    },
    computed: {
      mapSelectWidth() {
        // 返回null，表示使用传入组件的默认宽度
        return isMeaningful(this.width) ? defaultVal(this.width[0], null) : null;
      },
      mapDateWidth() {
        // 返回null，表示使用传入组件的默认宽度
        return isMeaningful(this.width) ? defaultVal(this.width[1], null) : null;
      },
    },
    data() {
      return{
        shortcutText: null
      }
    },
  }
</script>

<style lang="scss" scoped>
   .gj-select /deep/ .el-input .el-input__inner {
     border-top-right-radius: 0;
     border-bottom-right-radius: 0;
     z-index: 2;
   }
   .gj-select /deep/ .is-focus .el-input__inner {
      border-right-color: rgba($color: #1F6EEF, $alpha: 1);
    }
   .gj-select /deep/ .el-input .el-input__inner {
     border-top-right-radius: 0;
     border-bottom-right-radius: 0;
   }
   /deep/ .el-date-editor.el-input__inner,
   /deep/ .el-date-editor .el-input__inner {
     border-top-left-radius: 0;
     border-bottom-left-radius: 0;
   }
   /deep/ .el-date-editor{
     border-left-color: rgba($color: #000000, $alpha: 0);
     &:hover{
       border: 1px solid #1F6EEF;
     }
     &.is-active{
       border: 1px solid #1F6EEF;
     }
   }
   
</style>
